import {events} from '../../../systems/events';
import SETTING_EVENT from '../events';

export const setActiveSettingItem = (itemKey) => events.dispatch(SETTING_EVENT.ACTIVE_MENU_ITEM, {item: itemKey});